import Image from 'next/image';
import { useMedia } from 'react-use';

import { breakpoints } from '../../../styles/util';
import { StyledH2, StyledParagraph, StyledPrimaryCell } from '../utils';

export function SetPriceTimeSection() {
  const isMobile = useMedia(breakpoints.mobile, false);

  return (
    <StyledPrimaryCell className="bg-[url(/images/limit-orders/diagonal-lines-2.svg),_url(/images/limit-orders/ring-lines.svg),_#f9f9fb] bg-no-repeat bg-[top_left,_center_right] desktop:bg-[url(/images/limit-orders/diagonal-lines-2.svg),_url(/images/limit-orders/ring-lines.svg),_#f9f9fb] desktop:bg-[top_left,_right_140px] rounded-t-[2.25rem] flex-col items-stretch justify-start pt-10 pl-10 pr-0 pb-10 relative gap-0 tablet:flex-row-reverse tablet:items-center tablet:justify-around tablet:pt-3.5 tablet:pr-12 tablet:pb-4.5 desktop:justify-center desktop:pt-4 desktop:pl-4 desktop:pr-4 desktop:pb-4 desktop:gap-[100px]">
      <div className="max-w-[315px] tablet:max-w-[363px] tablet:ml-[-220px] tablet:pl-12 desktop:ml-0 desktop:mr-auto desktop:pl-0">
        <StyledH2>
          Set price, time,
          <br /> and sit tight
        </StyledH2>
        <StyledParagraph>
          Place a limit order to buy or sell crypto at an exact price within a chosen period.
        </StyledParagraph>
      </div>
      <Image
        src={`/images/limit-orders/chart-green-single-token${isMobile ? '-mobile' : ''}.png`}
        width={isMobile ? 399 : 673}
        height={342}
        alt=""
        className="rounded-l-[1.25rem] mt-14 tablet:mt-0 w-full h-auto self-end mr-0 tablet:relative max-w-[500px] tablet:right-[220px] tablet:max-w-[670px] desktop:right-0 filter-[drop-shadow(0px_4px_42px_rgba(0,0,0,0.06))_drop-shadow(0px_2px_6px_rgba(0,0,0,0.05))]"
      />
    </StyledPrimaryCell>
  );
}
